// @flow

import React from "react";
import {
  Button,
  Grid,
  Card,
  Table,
  Form,
  Page,
  Icon
} from "tabler-react";
import Select from 'react-select';
import { Link, withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SiteWrapperSuperAdmin from "./SiteWrapper.superadmin.react";
import clientService from "../services/client";
import userService from "../services/user";
import Bot from "../services/bot";
import authActions from "../redux/auth/action"
import { validate } from '../validate';
import Buttonloader from '../common/Loader/Buttonloader'
import CsvErrorMesage from './CsvErrorMessage';
import { changeLanguage } from '../../src/language/index'
import $ from 'jquery';
import Moment from 'moment';
import DownloadPopup from "./DownloadPopup";
import { loadingStatesKeys } from "../constants";
import { StateContext } from "../context/StateContext";
import { LuLoaderCircle } from "react-icons/lu";
import ShareTabReportData from "./ShareTab-report-status-react"


const validationRules = [
  {
    field: 'name',
    validations: ['max:50'],
    name: 'Name'
  },
  {
    field: 'countryCode',
    validations: ['required'],
    name: 'Country Code'
  },
  {
    field: 'contactNumber',
    validations: ['required', 'numeric'],
    name: 'Contact Number'
  },
  {
    field: 'email',
    validations: ['email'],
    name: 'Email'
  },
  {
    field: 'userType',
    validations: ['required'],
    name: 'User Type'
  }
];

class ShareData extends React.Component {
  static contextType = StateContext
  constructor(props) {
    super(props)
    this.state = {
      openDownloadPopup: {
        open: false,
        data: false,
      },
      viewType: 'erp',
      currentPage: 1,
      users: [],
      pageLoading: true,
      currentPage: this.props.match.params.page,
      nextPage: false,
      prevoiusPage: false,
      selectedFile: '',
      selectedImages: '',
      csvTotalUsers: 0,
      erpTotalUsers: 0,
      manualTotalUsers: 0,
      csvTotalUsersTab: 0,
      erpTotalUsersTab: 0,
      manualTotalUsersTab: 0,
      userTypes: [],
      clientId: this.props.match.params.clientId,
      selectedOptionUserType: {},
      fileName: changeLanguage(this.props.siteLanguage, 'select_file'),
      templateType:['image','video','audio','text','file','interactive button'],
      selectedTemplateType: {},
      fields: {
        name: '',
        contactNumber: '',
        email: '',
        userType: '',
        countryCode: '91',
      },
      message: {
        style: 'success',
        text: ''
      },
      dynamicFields: [],
      errors: {},
      isLoading: false,
      openPopupCsv: false,
      values: '',
      selectedFileUser: '',

      // --- NEW FILTER STATE ---
      filterSelectAll: true,
      filterSelectedTemplate: null,
    }


    this.handleTabActive = this.handleTabActive.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.onChangeFileUser = this.onChangeFileUser.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCreateUser = this.handleCreateUser.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setLoadingToggle = this.setLoadingToggle.bind(this);
    this.handleNotification = this.handleNotification.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.closeDownloadPopup = this.closeDownloadPopup.bind(this);
  }

  componentDidMount() {
    if (this.props.user.role === 'admin') {
      this.props.history.push(`/client/${this.state.clientId}/analytics`);
    }
    document.title = "Voiceoc | Dashboard";
    this.pagination(false, this.state.currentPage, this.state.viewType);
    this.getUserTypes();
  }

  getUserTypes() {


    Bot.getTempltes(1, 1000)
      .then(res => {
        if (res.statusCode === 200) {
          this.setState(() => ({
            userTypes: res.data.result,
          }));
        }
      }).catch(error => {})
  }

  handleTabActive = (tab) => {
    this.setState({
      viewType: tab,
      currentPage: 1
    });
    this.pagination(false, 1, tab);
  }

callService(page, tab = 'erp') {
    this.context.setLoading(loadingStatesKeys.notifications, true)    // FIX: Use .value (database key) instead of .label (display text)
    const selectedTemplate = this.state.filterSelectedTemplate ? this.state.filterSelectedTemplate.label : null;

    clientService.getNotification(page, tab, selectedTemplate)
      .then(res => {
        if (res.statusCode === 200) {
          let erp = res.data.notificationCount.find(x => x.notificationType === 'erp');
          let manual = res.data.notificationCount.find(x => x.notificationType === 'manual');
          let csv = res.data.notificationCount.find(x => x.notificationType === 'csv');

          this.setState(() => ({
            users: res.data.result,
            pageLoading: false,
            nextPage: res.data.next,
            prevoiusPage: this.state.currentPage > 1 ? true : false,
            csvTotalUsers: res.data.total,
            erpTotalUsers: res.data.total,
            manualTotalUsers: res.data.total,
            csvTotalUsersTab: csv ? csv.count : 0,
            erpTotalUsersTab: erp ? erp.count : 0,
            manualTotalUsersTab: manual ? manual.count : 0
          }));
        }
      }).catch(error => {
        this.setState(() => ({
          pageLoading: false
        }));
      }).finally(() => {
        this.context.setLoading(loadingStatesKeys.notifications, false)
      })
  }

  pagination(e = false, page, tab) {
    this.callService(page, tab);
    this.props.history.push("/admin/" + this.state.clientId + "/dashboard/" + page);
  }

  formReset() {
    document.getElementById("csvForm").reset();
  }

  onChangeFileUser = (event) => {
    if (event.target.files[0].type === "image/jpeg" || event.target.files[0].type === "image/jpg" || event.target.files[0].type === "image/png" || event.target.files[0].type === 'application/pdf') {
      this.setState({ selectedFileUser: event.target.files[0] });
    }
    else {
      toast.error('Please select only image');
      this.formReset();
    }
  }
 
  onChangeFile = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];

    if (event.target.id === 'image') {
      const validTypes = [
        'application/pdf',
        'image/jpeg',
        'image/jpg',
        'image/png'
      ];

      if (validTypes.includes(file.type)) {
        this.setState({ selectedImages: files });
      } else {
        toast.error('Please select a valid file (PDF/Image)');
        this.formReset();
        return;
      }
    } else {
      const extension = file.name.split('.').pop().toLowerCase();

      if (['csv', 'xls', 'xlsx'].includes(extension)) {
        this.setState({
          selectedFile: file,
          fileName: file.name
        });
      } else {
        toast.error('Please select csv/xls/xlsx file to upload');
        this.formReset();
        return;
      }
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    if (this.state.selectedFile === null || this.state.selectedFile == '') {
      toast.error('Please select csv file to upload');
      this.formReset();
      return false;
    }
    else {
      let data = new FormData();
      if (this.state.selectedImages !== null || this.state.selectedImages != '') {
        for (let i = 0; i < this.state.selectedImages.length; i++) {
          await data.append(`media`, this.state.selectedImages[i])
        }
      }

      await data.append('notification_file', this.state.selectedFile);
      await clientService.notificationImportByCsv(data)
        .then(response => {
          if (response.data.length) {
            var arr = response.data.map(function (val) { return ++val; });
            const errorRows = arr.join();
            this.openCsvPopup("Rows " + errorRows + " were not uploaded, please correct the data & try again. Thanks!")
          }
          else {
            toast.success("User imported successfully.")
          }
          this.setState(() => ({
            fileName: 'select file',
          }));
          this.pagination(false, 1, this.state.viewType);
          this.formReset();
        })
        .catch(error => {});
    }
  }

  openCsvPopup(mesage) {
    this.setState({ openPopupCsv: { open: true, data: mesage, } })
  }

  closePopup(data) {
    this.setState({ openPopupCsv: { open: false, data: false } })
  }

  closeDownloadPopup() {
    this.setState({ openDownloadPopup: { open: false, data: false } })
  }

  openDownloadPopup() {
    this.setState({ openDownloadPopup: { open: true, data: false } })
  }

  handleCreateUser = async event => {
    event.preventDefault();
    if (this.validate()) {
      const queationValues = this.validateQuestions();
      this.setLoadingToggle(true);

      let data = new FormData();
      let result = this.state.dynamicFields.forEach((value, index) => {
        data.append(value.value, queationValues[index]);
      })

      data.append('phoneNumber', this.state.fields.countryCode + this.state.fields.contactNumber);
      data.append('event', this.state.selectedOptionUserType.label);
      data.append('media', this.state.selectedFileUser);

      clientService.notificationCreate(data)
        .then(response => {
          toast.success("User created successfully.")
          this.setLoadingToggle(false);

          var firstObj = {};
          var typeValue = '';
          if (this.state.userTypes.length) {
            firstObj = {
              label: this.state.userTypes[0].name,
              value: this.state.userTypes[0]._id
            }
            typeValue = this.state.userTypes[0].name;
          }

          const { fields } = this.state;
          fields['userType'] = typeValue;
          fields['countryCode'] = '91';

          this.setState(() => ({
            pageLoading: true,
            fields: { name: '', contactNumber: '', countryCode: '91', email: '', userType: typeValue, },
            selectedOptionUserType: firstObj,
            dynamicFields: [],
          }));
          this.callService(1, this.state.viewType);
        })
        .catch(error => {
          setTimeout(() => {
            this.handleNotification();
          }, 3000)
          this.setLoadingToggle(false);
        })
    }
  }

  validateQuestions() {
    var options = [];
    $('.template-option').each(function (index, ele) {
      var $optionele = $(ele).next();
      let textclass = $(ele).find('.textclass').val();
      if (textclass == '') {
        options = [];
        return false;
      }
      options.push(textclass.toString());
    });
    return options;
  }

  handleNotification() {
    this.setState(() => ({ message: { text: '', style: '' } }));
  }

  handleChange = (e, field) => {
    const { fields } = this.state, val = e.target.value;
    fields[field] = val;
    this.setState({ fields });
  }

  validate() {
    const { fields } = this.state;
    const { isValid, errors } = validate(fields, validationRules);
    this.setState({ errors });
    return isValid;
  }

  setLoadingToggle(value) {
    this.setState({ isLoading: value });
  }

  fieldChanged = (fieldId, value) => {
    this.setState({ values: value })
  }

  handleChangeUserType = selectedOptionUserType => {
    const { fields } = this.state;
    fields['userType'] = selectedOptionUserType.label;
    let dynamicData = this.state.userTypes.find(x => x._id === selectedOptionUserType.value).dynamicFields;

    let res = dynamicData.map((value, index) => {
      return ( { value: value, index: index } )
    })

    this.setState( { selectedOptionUserType: selectedOptionUserType, dynamicFields: res, fields } );
  }

  getPagination() {
    var recordEndTo = 0;
    var totalRecord = 0;
    var page = this.props.match.params.page;
    var startRecord = this.props.match.params.page == 1 ? this.props.match.params.page : ((10 * (this.props.match.params.page - 1)) + 1)
    var type = this.state.viewType
    if (type === 'erp') { totalRecord = this.state.erpTotalUsers; }
    if (type === 'manual') { totalRecord = this.state.manualTotalUsers; }
    if (type === 'csv') { totalRecord = this.state.csvTotalUsers; }
    if (this.state.users.length < 1) {
      return '0-0 of ' + totalRecord;
    }
    else {
      var endRecord = (parseInt(startRecord) + parseInt(this.state.users.length) - 1);
      return startRecord + '-' + endRecord + ' of ' + totalRecord;
    }
  }

  // --- NEW FILTER EVENT HANDLERS ---
handleFilterSelectAll = (e) => {
    const isChecked = e.target.checked;
    
    this.setState({
      filterSelectAll: isChecked,
      // If checked, clear out the selected template dropdown
      filterSelectedTemplate: isChecked ? null : this.state.filterSelectedTemplate
    }, () => {
      // --- THE MISSING PIECE ---
      // If the user clicked "Select All", tell the backend to fetch the unfiltered data!
      if (isChecked) {
        this.pagination(false, 1, this.state.viewType);
      }
    });
  }

handleFilterTemplateChange = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    this.setState({
      filterSelectedTemplate: selectedOption,
      filterSelectAll: false 
    }, () => {
      this.pagination(false, 1, this.state.viewType);
    });
  }

  render() {

    const { users, pageLoading, nextPage, fileName, message, userTypes, filterSelectAll, filterSelectedTemplate } = this.state;
    const optionUserTypes = userTypes.map(elm => ({ label: elm.templateName, value: elm._id }));
    const { selectedOptionUserType } = this.state;
    const {isLoading} = this.context

    // --- APPLY FRONTEND FILTER TO CURRENT PAGE VIEW ---
    const displayedUsers = (filterSelectAll || filterSelectedTemplate) ? users : [];
    console.log("filterselectedtemplate", filterSelectedTemplate);
    
    return (
      <SiteWrapperSuperAdmin>
        <Page.Content className="m-0">
          <Grid.Row>
            <Grid.Col lg={6}>
              <Card>
                <Card.Header className="alignselfcenter">
                  <div className="tabs">
                    <Card.Title className={this.state.viewType === 'erp' ? 'active_tab' : ''}>
                      <Link to="#" onClick={(e) => this.handleTabActive('erp')}>{changeLanguage(this.props.siteLanguage, 'erp')}({this.state.erpTotalUsersTab})</Link>
                    </Card.Title>
                    <Card.Title className={this.state.viewType === 'csv' ? 'active_tab' : ''}>
                      <Link to="#" onClick={(e) => this.handleTabActive('csv')}>{changeLanguage(this.props.siteLanguage, 'csv')}({this.state.csvTotalUsersTab})</Link>
                    </Card.Title>
                    <Card.Title className={this.state.viewType === 'manual' ? 'active_tab' : ''}>
                      <Link to="#" onClick={(e) => this.handleTabActive('manual')}>{changeLanguage(this.props.siteLanguage, 'manual')}({this.state.manualTotalUsersTab})</Link>
                    </Card.Title>
                    <Card.Title >
                      <Link to="#" onClick={(e) => { this.openDownloadPopup() }}>
                      Download
                      </Link>
                    </Card.Title>
                  </div>
                </Card.Header>

              {/* --- NEW FILTER UI SECTION --- */}
                <div style={{ padding: '15px 20px', display: 'flex', alignItems: 'center', gap: '20px', borderBottom: '1px solid rgba(0,40,100,0.12)', backgroundColor: '#f8f9fa' }}>
                  <label style={{ display: 'flex', alignItems: 'center', margin: 0, cursor: 'pointer', fontWeight: 600 }}>
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={filterSelectAll}
                      onChange={this.handleFilterSelectAll}
                    />
                    Select All
                  </label>
                  <div style={{ width: '300px' }}>
                    <Select
                      value={filterSelectedTemplate}
                      onChange={this.handleFilterTemplateChange}
                      options={optionUserTypes}
                      isDisabled={filterSelectAll}
                      placeholder="Filter by Template Name..."
                      // --- MINIMAL FIX: Force dropdown menu to float above the table ---
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 })
                      }}
                      // ---------------------------------------------------------------
                    />
                  </div>
                </div>
                {/* ----------------------------- */}

                <Table
                  cards={true}
                  striped={true}
                  responsive={true}
                  className="table-vcenter fixed-table"
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.ColHeader>{changeLanguage(this.props.siteLanguage, 'sl_no')}</Table.ColHeader>
                      <Table.ColHeader>{changeLanguage(this.props.siteLanguage, 'mobile_number')}</Table.ColHeader>
                      <Table.ColHeader>Template Name</Table.ColHeader>
                      <Table.ColHeader>Date</Table.ColHeader>
                      <Table.ColHeader>Message Status</Table.ColHeader>
                      {/* --- NEW RESPONSE COLUMN HEADER --- */}
                      <Table.ColHeader>Response</Table.ColHeader>
                      {filterSelectedTemplate && filterSelectedTemplate.label === "sparsh_appointment_reminder" && <Table.ColHeader>Branch</Table.ColHeader>}
                      {/* <Table.ColHeader >{changeLanguage(this.props.siteLanguage,'name')}</Table.ColHeader> */}
                      {/* <Table.ColHeader>{changeLanguage(this.props.siteLanguage,'status')}</Table.ColHeader> */}

                    </Table.Row>
                  </Table.Header>
                  {isLoading(loadingStatesKeys.notifications) ? (
                    <Table.Body>
                      <Table.Row>
                        <Table.Col colSpan={5}  >
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                            <LuLoaderCircle className="spinner" color="#296FFA" size={40} />
                          </div>
                        </Table.Col>
                      </Table.Row>
                    </Table.Body>
                  ) : (
                    <Table.Body>
                      {displayedUsers.length ?
                        displayedUsers.map((user, index) => (
                          <Table.Row key={index}>
                            <Table.Col>{index + 1}</Table.Col>
                            <Table.Col className="text-nowrap">{user.phoneNumber}</Table.Col>
                            <Table.Col className="text-nowrap">{user.event}</Table.Col>
                            <Table.Col className="text-nowrap">{user.createdAt && Moment(user.createdAt).format('DD/MM/YY h:mm a')}</Table.Col>
                            <Table.Col className="text-nowrap">{user.status}</Table.Col>
                            {/* --- NEW RESPONSE COLUMN DATA --- */}
                            <Table.Col className="text-nowrap font-weight-bold" style={{ color: '#467fcf' }}>
                              {user.respondText || '-'}
                            </Table.Col>
                            {filterSelectedTemplate && filterSelectedTemplate.label === "sparsh_appointment_reminder" && <Table.Col className="text-nowrap">{user.branch ? user.branch : '-'}</Table.Col>}
                          </Table.Row>
                        ))
                        :
                        <Table.Row>
                          <Table.Col colSpan={6} >{
                            !filterSelectAll && !filterSelectedTemplate 
                            ? "Please select a template from the filter above." 
                            : changeLanguage(this.props.siteLanguage, 'sorry_user_not_found')
                          }</Table.Col>
                        </Table.Row>
                      }
                    </Table.Body>
                  )}
                </Table>
                {/* pagination */}
                <div className="form-group" style={{ float: 'right' }}>
                  <label className="form-label"></label>
                  <div className="selectgroup align-to-right paginations">
                    <span>{this.getPagination()}</span>
                    <i
                      className={"fe " + (this.props.match.params.page <= 1 ? "not-active " : "cursorPointer ") + " fe-chevron-left"}
                      onClick={(e) => this.pagination(e, (parseInt(this.props.match.params.page) - 1), this.state.viewType)}
                      disabled={this.props.match.params.page <= 1}>
                    </i>
                    <i
                      className={"fe " + (!nextPage ? "not-active " : "cursorPointer ") + " fe-chevron-right"}
                      onClick={(e) => this.pagination(e, (parseInt(this.props.match.params.page) + 1), this.state.viewType)}
                      disabled={!nextPage}></i>
                  </div>
                </div>

              </Card>
            </Grid.Col>
            <Grid.Col lg={6}>
              <Card>
                <Card.Header>
                  <Card.Title> {changeLanguage(this.props.siteLanguage, 'user_create_form')}</Card.Title>
                </Card.Header>
                <Card.Body>
                  {!!message.text ?
                    <div className={'alert alert-' + message.style} >
                      <p>{message.text}</p>
                      <Icon prefix="fa" name="times" onClick={this.handleNotification}></Icon>
                    </div>
                    : null
                  }
                  <form onSubmit={this.handleCreateUser}>
                    <Form.FieldSet>
                      <div className="row">
                        <div className="col-xs-3 col-md-3">
                          <Form.Group isRequired label={changeLanguage(this.props.siteLanguage, 'country_code')}>
                            <Form.Input name="countryCode"
                              onChange={(e) => this.handleChange(e, 'countryCode')}
                              placeholder={changeLanguage(this.props.siteLanguage, 'country_code')}
                              value={this.state.fields.countryCode} />
                            <label style={{ display: this.state.errors.countryCode ? 'block' : 'none' }} className="error">{this.state.errors.countryCode}</label>
                          </Form.Group>
                        </div>
                        <div className="col-xs-9 col-md-9">
                          <Form.Group isRequired label={changeLanguage(this.props.siteLanguage, 'contact_number')}>
                            <Form.Input name="contactNumber"
                              onChange={(e) => this.handleChange(e, 'contactNumber')}
                              placeholder={changeLanguage(this.props.siteLanguage, 'contact_number')}
                              value={this.state.fields.contactNumber} />
                            <label style={{ display: this.state.errors.contactNumber ? 'block' : 'none' }} className="error">{this.state.errors.contactNumber}</label>
                          </Form.Group>
                        </div>
                      </div>

                      <div className="form-group">
                        <label className="form-label">{changeLanguage(this.props.siteLanguage, 'template')}<span className="form-required">*</span></label>
                        <Select
                          value={selectedOptionUserType}
                          onChange={this.handleChangeUserType}
                          options={optionUserTypes}
                          defaultValue={selectedOptionUserType}
                        />
                        <label style={{ display: this.state.errors.userType ? 'block' : 'none' }} className="error">{this.state.errors.userType}</label>
                      </div>

                      <div className="all_options">
                        {
                          this.state.dynamicFields &&
                          this.state.dynamicFields.length > 0 &&
                          this.state.dynamicFields.map((val, index) => {
                            return (
                              <div className={`template-option_${index + 1} template-option`} key={index}>
                                <Form.FieldSet className="del109">
                                  <div >
                                    <Form.Group
                                      isRequired
                                      label={val.value}
                                      className="options">
                                      <Form.Input name="options[]"
                                        placeholder='Text'
                                        className="textclass"
                                      />
                                    </Form.Group>
                                  </div>
                                </Form.FieldSet>
                              </div>
                            )
                          })
                        }
                        <div>
                          <span className="form-label">
                            Media Upload:- <span className="form-required">*</span>
                          </span>
                          <div className="file">
                            <input name="example-text-input" type="file" onChange={(e) => this.onChangeFileUser(e)} />
                            <span className="file-custom">{this.state.selectedFileUser.name || "No file chosen"}</span>
                          </div>
                        </div>
                      </div>
                    </Form.FieldSet>

                    {!this.state.isLoading ?
                      <Button color="btn btn-primary btn-block btn-block aligncentre" type="submit">{changeLanguage(this.props.siteLanguage, 'create')}</Button>
                      :
                      <Buttonloader
                        loading={this.state.isLoading}
                        addNewClass="col-lg-4 aligncentre"
                      ></Buttonloader>
                    }
                  </form>
                  <ToastContainer autoClose={5000} position={'bottom-right'} />
                </Card.Body>
              </Card>
              <Card>
                <Card.Header>
                  <Card.Title>{changeLanguage(this.props.siteLanguage, 'upload_using_csv')}</Card.Title>
                </Card.Header>
                <Link className="backcolor link-w" to="../../../demo/testfile.csv" download target="_blank">
                  {changeLanguage(this.props.siteLanguage, 'click_to_download')}
                </Link>
                {/* <Table
                  cards={true}
                  striped={true}

                  className="table-vcenter table-re"
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.ColHeader className="text-tranform"></Table.ColHeader>
                    </Table.Row>
                  </Table.Header>
                </Table> */}
                <form id="csvForm" onSubmit={this.handleSubmit.bind(this)}>
                  <Form.FieldSet className="col-lg-12">
                    <Form.Group label="" className="upload-cont">
                      <div className="row card-header">
                        <div className="col-sm-12">
                          <span className="form-label">
                            {" "}
                           Csv Upload : <span className="form-required">*</span>
                            </span>
                          <div className="file">
                            <input id="csv" name="example-text-input" type="file" onChange={(e) => this.onChangeFile(e)} required />
                            <span className="file-custom">{this.state.selectedFile.name || "No file chosen"}</span>
                          </div>
                            {/* <input id="csv" name="example-text-input" type="file" onChange={(e) => this.onChangeFile(e)} required /> */}
                        </div>
                        <div className="col-sm-12">
                          <span className="form-label">
                            Media Upload:- <span className="form-required">*</span>
                          </span>
                          <div className="file">
                            <input id="image" name="image" type="file" accept="image/*,application/pdf" multiple  onChange={(e) => this.onChangeFile(e)} />
                            <span className="file-custom">{this.state.selectedImages.length > 0 ? this.state.selectedImages[0].name : "No file chosen"}</span>
                          </div>
                              {/* <input id="image" name="image" type="file" accept="image/*,application/pdf" multiple  onChange={(e) => this.onChangeFile(e)} /> */}
                        </div>
                      </div>
                    </Form.Group>
                    <Button color="primary btn-block " className=" btn-block aligncentre" type="submit">{changeLanguage(this.props.siteLanguage, 'import')}</Button>
                  </Form.FieldSet>
                </form>
              </Card>
            </Grid.Col>
            <CsvErrorMesage
              openPopup={this.state.openPopupCsv}
              onChange={this.closePopup}
            ></CsvErrorMesage>
          </Grid.Row>
          <ShareTabReportData openInfoPopup={this.state.openDownloadPopup} onChange={this.closeDownloadPopup} />
        </Page.Content>
        <ToastContainer autoClose={5000} position={'bottom-right'} />
      </SiteWrapperSuperAdmin >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    siteLanguage: state.auth.siteLanguage
  }
}

function mapDispatchToProps(dispatch) {
  return {
    logOut: () => {
      dispatch(authActions.authLogout())
    }
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareData));